module.exports = __webpack_public_path__ + "img/wechatXacode.63679f35.jpg";